export default __webpack_public_path__ + "static/media/button-blue.8dc44e2f.svg";